<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-31 09:57:55
 * @LastEditTime: 2019-10-28 17:23:57
 * @LastEditors: 陆伟
 -->
<template>
  <div class="coupon-content">
    <!-- 头像 -->
    <div class="head-portrait-data">
      <div class="head-portrait">
        <img :src="nationCouponData.giveHeadUrl" alt />
      </div>
      <div class="head-name">{{nationCouponData.giveNickName}}</div>
      <div class="head-tip">
        <span class="triangle"></span>送你一个大红包，快去选择喜欢的商品吧~
      </div>
    </div>
    <!-- 领取文案 -->
    <div class="receive-success" v-if="nationCouponData.getResultType == 0 || nationCouponData.getResultType == 1  || nationCouponData.getResultType == 3">{{nationCouponData.getMarkWords}}</div>
    <!-- 领取优惠劵 -->
    <div class="coupon-info">
      <!-- 非单品券-优惠劵 -->
      <div class="no-voucher">
        <!-- 0 领取成功 1 已领过 2 已抢光 3 领取上限 4 已领取上限 -->
        <div v-show="nationCouponData.getResultType == 0 || nationCouponData.getResultType == 1  || nationCouponData.getResultType == 3">
          <div class="coupon-cont">
            <div class="coupon-cont-l"><i class="rmb">¥</i>{{couponUser.value}}</div>
            <div class="coupon-cont-r">
              <p class="coupon-title">{{couponUser.showName}}</p>
              <div class="coupon-full">满{{couponUser.useValue}}可用<br />{{couponUser.startTime|formatNew}}-{{couponUser.endTime|formatNew}}</div>
            </div>
          </div>
          <!-- 未生效 -->
          <div class="status-icon unactive" v-if="couponUser && couponUser.canUse == 1">&nbsp;</div>
          <div class="scope ui-rows" v-show="couponUser.scopeName && nationCouponData.single == 0">
            <span class="scope-one ui-cols" :class="{'scope-one-hiddle':!isShowScope}">
              {{couponUser.scopeName}}
              <i v-if="couponUser.useScopeDesc">&nbsp;&nbsp;:&nbsp;&nbsp;{{couponUser.useScopeDesc}}</i>
            </span>
            <span class="ui-cols ui-cols-10" style="position:relative">
              <i class="scope-icon scope-open" v-show="isShowScopeIcon" @click="openScope()"></i>
            </span>
          </div>
        </div>
        <!-- 已达上限/失效/抢光了 -->
        <div class="voucher" v-if="nationCouponData.getResultType != 0 && nationCouponData.getResultType != 1 && nationCouponData.getResultType != 3">
          <div class="coupon-invalid" v-if="nationCouponData.getResultType == 2 || nationCouponData.getResultType == 4">{{nationCouponData.getMarkWords}}</div>
          <!-- <div class="coupon-finish" v-if="nationCouponData.getResultType == 3"> -->
          <!-- <span class="coupon-finish-t">{{nationCouponData.getMarkWords}}</span> -->
          <!-- <span class="coupon-finish-s">{{nationCouponData.limitWords}}</span> -->
          <!-- </div> -->
          <div class="coupon-end" v-if="nationCouponData.getResultType == 2 && nationCouponData.single == 0">
            {{nationCouponData.value}}元大红包已被幸运儿
            <img class="coupon-img" :src="nationCouponData.getterHeadUrl" alt />
            <span>{{nationCouponData.getterNickName}}</span> 领取
          </div>
        </div>
        <!-- 单品劵商品 -->
        <div class="coupon-single ui-rows" v-for="(item,index) in singleProduct" :key="index" v-if="singleProduct && singleProduct.length > 0 && nationCouponData.single == 1 && nationCouponData.getResultType != 4 && index < 1">
          <div class="coupon-single-l">
            <img :src="item.itemImgSmall" alt />
          </div>
          <div class="coupon-single-r">
            <div class="coupon-zhu-title" :class="item.itemCategory != 3 && item.subtitle != '' ? 'ui-nowrap-one-new' : 'ui-nowrap-two'">{{item.itemName}}</div>
            <div class="ui-nowrap-one-new coupon-sub-title" v-if="item.itemCategory != 3 && item.subtitle != ''">{{item.subtitle}}</div>
            <div class="ui-rows-m item-price">
              <em class="item-curr-price">
                <i class="price-right">&yen;</i>
                {{item.itemPrice}}
              </em>
              <em class="item-pre-price">
                <i class="price-right">&yen;</i>
                {{item.itemVipPrice}}
              </em>
            </div>
          </div>
        </div>
        <div class="coupon-end" v-if="nationCouponData.getResultType == 2 && nationCouponData.single == 1">
          {{nationCouponData.value}}元大红包已被幸运儿
          <img class="coupon-img" :src="nationCouponData.getterHeadUrl" alt />
          <span>{{nationCouponData.getterNickName}}</span> 领取
        </div>
        <!-- 0 领取成功 1 已领过 2 已抢光 3 领取上限 4 已领取上限 -->
        <div class="coupon-put-in-text" v-if="(nationCouponData.getResultType == 0 || nationCouponData.getResultType == 1) && nationCouponData.getterPhone">
          优惠券已放入
          <span>{{nationCouponData.getterPhone}}</span> 账户
          <div @click="checkCoupons()" class="checkCoupons">查看我的优惠券</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import YunJi from '@/assets/js/YunJi'
import { isWxProgram } from '@/assets/js/Util'

export default {
  name: 'coupon-item',
  data() {
    return {
      isShowScope: false
    }
  },
  props: {
    nationCouponData: {
      type: Object,
      default() {
        return {}
      }
    },
    couponUser: {
      type: Object,
      default() {
        return {}
      }
    },
    singleProduct: {
      type: Array,
      default() {
        return []
      }
    },
    isShowScopeIcon: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  activated() {},
  filters: {
    formatNew(value) {
      return YunJi.formatNew(value, 'MM/dd hh:mm')
    }
  },
  methods: {
    /**
     * 点击展开使用范围
     */
    openScope() {
      // if (!this.isShowScope) {
      //   this.isShowScope = true
      //   // document.querySelector('.scope-one').removeClass('scope-one-hiddle')
      //   // document.querySelector('.scope-icon').removeClass('scope-open').addClass('scope-close')
      // } else {
      //   this.isShowScope = false
      //   document.querySelector('.scope-one').addClass('scope-one-hiddle')
      //   document.querySelector('.scope-icon').removeClass('scope-close').addClass('scope-open')
      // }
      this.isShowScope = !this.isShowScope
    },
    // 查看我的优惠券
    checkCoupons() {
      this.$parent.toExportItem()
      if(this.$parent.thinkingReport) {
        this.$parent.thinkingReport('others', {
          point_id: '21555'
        })
      }
      if (isWxProgram()) {
        wx.miniProgram.navigateTo({ url: `/pages/coupon-list/coupon-list?shopId=${this.shopId}&from=wo` })
        return 
      }
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/coupon-canuse?shopId=${this.nationCouponData.giveShopId}&appCont=0`
    }
  }
}
</script>

<style>
.coupon-content{
  height: 100%;
  width: 100%;
  position: relative;
}
.scope {
  background: rgba(255, 255, 255, 0.9);
  width: 100%;
  font-size: 0.2rem;
  color: #666;
  padding: 0.1rem 0;
  position: relative;
}
.scope::after{
  content: '';
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.9);
  position: absolute;
  left: 0;
  top: -1px;
}
.scope-one {
  display: inline-block;
  width: 5.54rem;
  margin-left: 0.2rem;
  line-height: 0.28rem;
}
.scope-one-hiddle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scope-icon {
  display: inline-block;
  width: 0.24rem;
  height: 0.24rem;
  position: absolute;
  top: 0.02rem;
  right: 0.18rem;
}
.scope-open {
  background: url("//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/icon-open.png")
    no-repeat;
  background-size: 100% 100%;
}
.scope-open.all {
  transform: rotate(180deg);
}
.scope-close {
  background: url("//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/icon-close.png")
    no-repeat;
  background-size: 100% 100%;
}
.no-voucher{
  position: relative;
  overflow: hidden;
}
.status-icon{
  position: absolute;
  right: -.12rem;
  top: -.12rem;
  z-index: 0;
  width: 1.04rem;
  height: 1.04rem;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.status-icon.unactive {
  background-image: url('https://static.yunjiglobal.com/qnUpload/frontend/shareCoupon/coupon_status.png?1=1')
}


</style>
